import { Controller } from '@hotwired/stimulus'

// Управляет видимостью fieldset-ов внутри строки условия/эффекта промокода.
// При смене типа в селекте показывает только соответствующий блок полей.
//
// HTML контракт:
//   <div data-controller="promo-rule-fields">
//     <select data-promo-rule-fields-target="typeSelect"
//             data-action="change->promo-rule-fields#sync">
//       <option value="PromoConditions::MinOrderAmount">...</option>
//       ...
//     </select>
//     <div data-promo-rule-fields-target="fieldset" data-rule-type="PromoConditions::MinOrderAmount">
//       <input name="...[human][amount]">
//     </div>
//     <div data-promo-rule-fields-target="fieldset" data-rule-type="PromoConditions::Weekday">
//       ...
//     </div>
//   </div>
export default class extends Controller {
  static targets = ['typeSelect', 'fieldset']

  connect () {
    this.sync()
  }

  sync () {
    const selected = this.typeSelectTarget.value
    this.fieldsetTargets.forEach((fs) => {
      const matches = fs.dataset.ruleType === selected
      fs.hidden = !matches
      // Поля в скрытом fieldset не отправляются — disabled выключает отправку
      fs.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = !matches
      })
    })
  }
}
